'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { CommunicatorLogger } from 'calling-lifecycle-usage-tracker/callingTracker';
import { NO_CALL_ACCESS_SCOPE } from 'calling-lifecycle-internal/calling-appeals/constants/pageActionKeys';
import { logPageAction } from 'calling-error-reporting/report/error';
import { CallingAccess } from 'calling-lifecycle-internal/constants/AccessLevels';
import CallingSuspensionMessage from './CallingSuspensionMessage';
import { Metrics } from '../../utils/Metrics';
import { jsx as _jsx } from "react/jsx-runtime";
class CallingSuspension extends PureComponent {
  componentDidMount() {
    CommunicatorLogger.log('callingInteraction', {
      action: 'View Appeal',
      activity: 'call',
      channel: 'outbound call',
      source: this.props.appIdentifier
    });
    logPageAction({
      key: NO_CALL_ACCESS_SCOPE,
      tags: {
        subType: CallingAccess
      }
    });
    Metrics.counter('no-call-access-scope').increment();
  }
  render() {
    return /*#__PURE__*/_jsx(CallingSuspensionMessage, {
      callingAccess: this.props.callingAccess,
      useFullWidth: this.props.useFullWidth,
      appIdentifier: this.props.appIdentifier
    });
  }
}
CallingSuspension.propTypes = {
  callingAccess: PropTypes.object.isRequired,
  appIdentifier: PropTypes.string.isRequired,
  useFullWidth: PropTypes.bool
};
export default CallingSuspension;